// Axios
import axios from "axios";

// Types
import { ILiveStreamResponse, IMemberPlan, TrialInfo } from "../types";

class LiveChannelService {
    async getAllLiveEvents(clientId: string): Promise<ILiveStreamResponse> {
        const response = await axios.get(
            `${process.env.REACT_APP_MEDIA_SERVICE_ENDPOINT}/streams/${clientId}`
        );

        console.log(response.data.data);
        return response.data.data;
    }

    async getPlaybackToken(
        channelId: string,
        sessionToken?: string
    ): Promise<string> {
        const config = {
            headers: {
                "content-type": "application/json",
                Authorization: sessionToken ?? "",
            },
        };
        const response = await axios.get(
            `${process.env.REACT_APP_LIVE_EVENTS_SERVICE_ENDPOINT}/channel/${channelId}/token`,
            { ...config }
        );

        return response.data.data;
    }

    async getCustomerPurchasedPlans(
        sessionToken: string
    ): Promise<IMemberPlan[]> {
        const config = {
            headers: {
                "content-type": "application/json",
                Authorization: sessionToken ?? "",
            },
        };
        const response = await axios.get(
            `${process.env.REACT_APP_MEDIA_SERVICE_ENDPOINT}/purchased-plans`,
            { ...config }
        );

        return response.data.data;
    }

    async checkTrialCodeUser(sessionToken: string): Promise<TrialInfo[]> {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_MEDIA_SERVICE_ENDPOINT}/freetrial-plans`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: sessionToken,
                    },
                    validateStatus: (status) => status < 500
                }

            );

            if (response.status >= 400) {
                return [];
            }

            return response.data.data;
        } catch (error: any) {
            return [];
        }
    }
}

export const liveChannelService = new LiveChannelService();
